import { apiCallWithAuthToken } from './config';

export const getLoginAttempts = (filter?: ApiFilter) =>
  apiCallWithAuthToken.get<LoginAttemptsData>(
    `login-attempts${filter ? `?filter=${JSON.stringify(filter)}` : null}`,
  );
